
import { useTaskForm } from "./task-form/useTaskForm";
import TaskFormHeader from "./task-form/TaskFormHeader";
import TaskFormFields from "./task-form/TaskFormFields";
import TaskFormActions from "./task-form/TaskFormActions";
import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import { useToast } from "@/hooks/use-toast";

const CreateTaskForm = ({ 
  onClose, 
  onTaskCreated,
  editingTaskId 
}: { 
  onClose: () => void, 
  onTaskCreated: () => void,
  editingTaskId?: string | null
}) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const { toast } = useToast();
  const { loading, formData, setFormData, handleSubmit } = useTaskForm(
    editingTaskId,
    onClose,
    onTaskCreated,
    isAdmin
  );

  useEffect(() => {
    const checkUserRole = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        if (!session) {
          toast({
            title: "Ikke logget ind",
            description: "Du skal være logget ind for at oprette opgaver",
            variant: "destructive"
          });
          return;
        }

        const { data: hasAdminRole } = await supabase.rpc('has_role', {
          user_id: session.user.id,
          role: 'admin'
        });
        
        setIsAdmin(hasAdminRole);
      } catch (error) {
        console.error('Fejl ved tjek af brugerrolle:', error);
        toast({
          title: "Fejl",
          description: "Kunne ikke verificere brugerrettigheder",
          variant: "destructive"
        });
      }
    };

    checkUserRole();
  }, [toast]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full max-h-[90vh] overflow-y-auto">
        <TaskFormHeader editingTaskId={editingTaskId} onClose={onClose} />
        <form onSubmit={handleSubmit} className="space-y-4">
          <TaskFormFields 
            formData={formData} 
            setFormData={setFormData} 
            isAdmin={isAdmin}
          />
          <TaskFormActions loading={loading} editingTaskId={editingTaskId} onClose={onClose} />
        </form>
      </div>
    </div>
  );
};

export default CreateTaskForm;
